// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centertitle[data-v-68108984]{font-size:4.533vw;margin:4vw 0}.rulebox[data-v-68108984]{font-size:4vw;margin:0 4vw}.rulebox div[data-v-68108984]{margin-top:4vw}", ""]);
// Exports
module.exports = exports;
